import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    textAlign: "center",
    position: "absolute",
    top: "250px",
    left: "0",
    right: "0",
  },
  stack: {
    margin: "0 10%",
  },
  textBody: {
    lineHeight: 2,
  },
  moveButton: {
    width: "12vw",
    backgroundColor: "#f2f2f2",
    color: "#555",
    marginTop: 15,
  },
};
